import React from 'react';

import ManageEntityList from './ManageEntityList';
import CharterRequestDetail from '../Editors/CharterRequestDetail';
import { Route } from 'react-router-dom';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';


const BidHistory = ({ item, route, headerHeight, parentHeight }) => {
  
    return <React.Fragment>
        <ManageEntityList item={item} route={route} parentHeight={parentHeight} entity={entities.supplierBidClient} headerHeight={headerHeight} />

        <Route path={route + '/:bidId'} render={() =>
            <ClientModal entity={entities.supplierBid} route={route} itemParam='bidId' >
                <CharterRequestDetail route={route} edit={false} placeBid />
            </ClientModal>} />
          
    </React.Fragment>

}
export default BidHistory;
